import { createContext, useContext, useEffect, useState } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../firebase';
import { DEMO_MODE } from '../data/demoData';

const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(DEMO_MODE ? { uid: 'demo-user', email: 'demo@local' } : {});

  const createUser = (email, password) => {
    if (DEMO_MODE) {
      setUser({ uid: 'demo-user', email: email || 'demo@local' });
      return Promise.resolve({ user: { uid: 'demo-user', email: email || 'demo@local' } });
    }
    return createUserWithEmailAndPassword(auth, email, password);
  };

   const signIn = (email, password) =>  {
    if (DEMO_MODE) {
      setUser({ uid: 'demo-user', email: email || 'demo@local' });
      return Promise.resolve({ user: { uid: 'demo-user', email: email || 'demo@local' } });
    }
    return signInWithEmailAndPassword(auth, email, password)
   }

  const logout = () => {
      if (DEMO_MODE) {
        setUser({ uid: 'demo-user', email: 'demo@local' });
        return Promise.resolve();
      }
      return signOut(auth)
  }

  useEffect(() => {
    if (DEMO_MODE) {
      setUser({ uid: 'demo-user', email: 'demo@local' });
      return () => {};
    }
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      //console.log(currentUser);
      setUser(currentUser);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider value={{ createUser, user, logout, signIn }}>
      {children}
    </UserContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
